import { apiNames, getNoVersion } from '@general/api/shared';

export const getOauthUserInfo = async () => {
    try {
        const response = await getNoVersion(apiNames.MEMBERSHIP, `oauth2/userinfo`);
        return response?.data || null;
    } catch (e) {
        return null;
    }
};
